import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeUtils } from '../utils';

@Pipe({
  name: 'timeFormatter',
  pure: false,
})
export class TimeFormatterPipe implements PipeTransform {
  public static format(
    value: Date,
    withoutSecond?: boolean
  ): string | null | undefined {
    if (!value) {
      return null;
    }

    return DateTimeUtils.formatTimeToString(value, withoutSecond);
  }

  transform(value: Date, withoutSecond?: boolean): string | null | undefined {
    return TimeFormatterPipe.format(value, withoutSecond);
  }
}
